import type { Ref } from "react";
import type { MazeDrawing } from "@/lib/tool-kit/games-organizers/maze-geometry";
import { strokeFor } from "@/lib/tool-kit/games-organizers/maze-geometry";

/**
 * A maze as a self-contained SVG: every colour and width is an attribute, so the
 * downloaded file looks the same outside the page. Walls are one path; the route is a
 * second, drawn only when asked for.
 */
export default function MazeSvg({
  drawing,
  showRoute,
  label,
  svgRef,
}: {
  drawing: MazeDrawing;
  showRoute: boolean;
  label: string;
  svgRef?: Ref<SVGSVGElement>;
}) {
  const wall = strokeFor(drawing, 0.45);
  const route = strokeFor(drawing, 0.8);
  const dot = strokeFor(drawing, 1.1);
  return (
    <svg
      aria-label={label}
      className="mx-auto block h-auto w-full max-w-[180mm]"
      ref={svgRef}
      role="img"
      viewBox={drawing.viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="#ffffff"
        height={drawing.height}
        width={drawing.width}
        x={drawing.viewBox.split(" ")[0]}
        y={drawing.viewBox.split(" ")[1]}
      />
      <path
        d={drawing.walls}
        fill="none"
        stroke="#111111"
        strokeLinecap="round"
        strokeWidth={wall}
      />
      {showRoute ? (
        <path
          d={drawing.route}
          fill="none"
          stroke="#d1242f"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={route}
        />
      ) : null}
      <circle
        cx={drawing.start.x}
        cy={drawing.start.y}
        fill="#111111"
        r={dot * 2.2}
      />
      <circle
        cx={drawing.finish.x}
        cy={drawing.finish.y}
        fill="#ffffff"
        r={dot * 2.6}
        stroke="#111111"
        strokeWidth={dot * 0.9}
      />
    </svg>
  );
}
